export const alertPaths = {
    default: '/alerts',
    rules: '/alerts/rules',
}

export default alertPaths;
